import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="privacy">
      <Header />
      <div className="otnotice-sections">
        <section
          className="otnotice-section"
          id="otnotice-section-6a3ede0c-7d6e-4060-819e-e97e80abaa55"
        >
          <div className="otnotice-section-content">
            <p>
              <span style={{ fontSize: 24 }}>Privacy Policy</span>
            </p>
            <p>
              <br />
            </p>
            <p id="isPasted">
              Last updated: March 21, 2025
              <br />
              &nbsp;
            </p>
            <p>
              This privacy policy ("Policy") explains how your information is
              collected, used, and disclosed by Parkhaven Living, LLC
              ("Parkhaven") and its parent company Columbia Sportswear Company
              and its subsidiaries and affiliated companies ("Parkhaven," “we,”
              “our,” or “us”). Unless we otherwise indicate, this Policy applies
              to the Websites and mobile applications (collectively, "Site"), as
              well as to the services owned, operated and/or provided by
              Parkhaven that display or link to this Policy, both online (such
              as on social media) and offline (such as at retail stores)
              (collectively with the Site, the “Services”).
              <br />
              &nbsp;
            </p>
            <p>
              By using the Services, you agree to our collection, use, and
              disclosure practices, and other activities, and those of our
              partners or those individuals or entities we engage to provide
              services in connection with your use of the Services, as described
              in this Policy. If you do not agree, please discontinue use of the
              Services.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>Your Preferences:</strong> If you receive our emails and
              catalogs and no longer wish to, just let us know. See the section
              on{" "}
              <a
                href="#otnotice-section-fe0ec16e-1bc1-472a-a16c-be4d77b9eec5"
                rel="noopener noreferrer"
              >
                &nbsp;Unsubscribing from our Marketing and Promotional
                Communications, Including Catalog Mailings
              </a>
              <br />
              &nbsp;
            </p>
            <p>
              For purposes of this Privacy Policy, “personal information” refers
              to information that identifies, relates to, describes, is
              reasonably capable of being associated with, or could reasonably
              be linked, directly or indirectly, to you, and includes “personal
              data” or similar terms as defined in applicable law.
              <br />
              &nbsp;
            </p>
            <p>
              This Policy has been designed to be accessible to people with
              disabilities. If you experience any difficulties accessing the
              information here, please contact Customer Service at (866)
              915-6457 or{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
              . &nbsp;&nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-abc60a93-93bb-41f2-883f-44fecd30237f"
        >
          <h2 className="otnotice-section-header">
            1. Notice at Collection of Personal Information
          </h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              We collect the categories of personal information identified
              below. As indicated in the chart, some of these categories we
              “sell” or “share” (as such terms are defined in California law)
              for marketing purposes to business partners and third parties,
              such as data analytics providers, advertising technology vendors,
              and social media platforms as described in this Policy. We do not
              knowingly sell or share personal information about persons under
              the age of 18 without affirmative authorization. Please click{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>{" "}
              to opt out of the sale or sharing of your personal information,
              including targeted advertising. You may also choose to enable
              online, where available, a universal tool that automatically
              communicates your opt-out preferences, such as the Global Privacy
              Control (“GPC”). We will process the GPC signal as a request to
              opt out, however, you will still need to follow instructions on
              the{" "}
              <Link onClick={toTop} to="/">
                “Do Not Sell or Share My Personal Information”
              </Link>{" "}
              page to opt out of certain offline sales or sharing of personal
              information.
            </p>
            <p>
              <strong id="isPasted">Text Messaging:</strong> Any information
              gathered through the Text Messaging program will not be shared
              with third parties or affiliates for marketing purposes.&nbsp;
              <br />
              &nbsp;
            </p>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      A. Category of Personal Information Collected
                    </strong>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Do we sell or share the category of Personal
                      Information?&nbsp;
                    </strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <p id="isPasted">
                      <strong>Identifiers/biographical information,</strong>{" "}
                      including name, postal and email address, phone number,
                      and date of birth.&nbsp;
                    </p>
                    · &nbsp;Online identifiers, Internet Protocol (“IP”)
                    address, and other similar identifiers.
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Yes&nbsp;</strong>
                    <br />
                    &nbsp;&nbsp;
                    <br />
                    <strong>Yes&nbsp;</strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <p id="isPasted">
                      <strong>
                        Personal information categories listed in the{" "}
                        <Link onClick={toTop} to="/">
                          California Customer Records statute
                        </Link>
                      </strong>
                      , such as:&nbsp;
                    </p>
                    <p>· &nbsp;your credit or debit card number</p>· billing
                    address
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">No&nbsp;</strong>
                    <br />
                    &nbsp;&nbsp;
                    <br />
                    <strong>Yes</strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Protected classification characteristics under{" "}
                      <Link onClick={toTop} to="/">
                        California law
                      </Link>
                    </strong>
                    , including age and gender.&nbsp;
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Commercial information</strong>,
                    including items purchased, obtained, or considered and other
                    purchasing or consuming histories or tendencies.
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Internet or other electronic network activity information
                    </strong>
                    , including browsing history, search history, and
                    interactions with a website, email, application, or
                    advertisement.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Geolocation data</strong>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Audio, electronic, visual, thermal, olfactory, or similar
                      information
                    </strong>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">No</strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">
                      Professional or employment-related information
                    </strong>
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Yes</strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Education information</strong>
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Inferences</strong>, meaning
                    inferences drawn from the above-listed categories of
                    personal information to create a consumer profile reflecting
                    consumer preferences or characteristics.
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">Yes</strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Sensitive Personal Information
                    </strong>
                    , such as online Parkhaven account log-in name or email and
                    corresponding password.
                    <br />
                    &nbsp;&nbsp;
                    <br />
                    <em>
                      We do not use or disclose such information for the purpose
                      of inferring characteristics about you or for any purpose
                      other than the limited permissible purposes set forth in
                      the regulations implementing California law. Such purposes{" "}
                      <em id="isPasted">
                        include providing our Services and verifying,
                        maintaining the quality of, and improving our Services.
                      </em>
                    </em>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    <strong id="isPasted">No</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>
                B. The Business and Commercial Purposes for Which We Collect and
                Use Your Personal Information:
              </strong>
            </p>
            <ul type="disc">
              <li>
                <strong>Product and Service Delivery.</strong> To provide and
                deliver our products and Services, including securing,
                troubleshooting, improving, and personalizing those products and
                Services.
              </li>
              <li>
                <strong>Business Operations.</strong> To operate our business,
                such as billing, accounting, improving our internal operations,
                securing our systems, and detecting fraudulent or illegal
                activity.
              </li>
              <li>
                <strong>Improvement, Development, and Research.</strong> To test
                and improve our products and Services, develop new products or
                features, and conduct research.
              </li>
              <li>
                <strong>Personalization.</strong> To provide you with customized
                content, targeted offers, and advertising in the Services, via
                email, SMS text, direct mail or across other websites, mobile
                applications, social media or online services you may use.
              </li>
              <li>
                <strong>Customer Support.</strong> To provide customer support
                including for product returns, and to respond to your questions.
              </li>
              <li>
                <strong>Community.</strong> To manage and administer our
                community features and member programs and services.
              </li>
              <li>
                <strong>Communications.</strong> To send you information,
                including confirmations, invoices, technical notices, updates,
                security alerts, and support and administrative messages, to
                invite you to participate in customer research opportunities,
                such as surveys and focus groups, and to process and deliver
                contest entries and awards.
              </li>
              <li>
                <strong>Marketing.</strong> To communicate with you about new
                products, offers, promotions, contests and sweepstakes, upcoming
                events, and other news offered by Parkhaven and our selected
                partners. If you add a product to your cart during the checkout
                process and don’t complete the purchase within a specified time,
                your cart will be considered as abandoned, and we may send an
                “abandoned cart” email that will enable you to complete the
                purchase by clicking the purchase link in the email; you can
                unsubscribe from such emails at any time by using the
                unsubscribe link provided in the emails.
              </li>
              <li>
                <strong>Advertising.</strong> To display advertising to you.
              </li>
            </ul>
            <p>
              <strong>C. Retention</strong>
            </p>
            <p>
              We will retain your personal information for as long as reasonably
              necessary to provide you with the Services that you request, for
              marketing purposes unless you opt out as described in our Policy,
              or otherwise where permitted or required in accordance with
              applicable law. We will retain and use your personal information
              as necessary to comply with our legal obligations, resolve
              disputes, and enforce our agreements. What this means in practice
              will vary between different types of information, and when we
              consider our approach we take into account ongoing business or
              legal needs for the information, for example in relation to tax,
              health and safety, and potential or actual disputes or
              investigations.
              <br />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-ac65cd61-b628-4f2e-933b-fff986cec0bb"
        >
          <h2 className="otnotice-section-header">
            2. Personal Information We Collect
          </h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              We collect information from you in various ways, including through
              information you provide to us directly, information we or other
              third parties automatically collect or infer, and information we
              receive from third parties. This includes data that identifies you
              personally whether directly (e.g., your name) or indirectly (e.g.,
              information about your online use). We refer to such data as
              personal information or personal data throughout this Policy.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>A. Information You Provide</strong>
            </p>
            <p>
              We collect information you directly provide to us through our
              Site, in our stores and through your other interactions with us.
              This may include when you use our Site, register or create an
              online account with or through the Site, purchase products,
              request information from us, sign up for newsletters, catalogs, or
              our email list, opt in to receive text messages, use our Services,
              enter into or win sweepstakes or other promotions, fill out a
              survey, request customer support, or otherwise communicate with or
              contact us.
              <br />
              &nbsp;
            </p>
            <p>
              The information we collect from you generally falls into the
              following categories:
              <br />
              &nbsp;
            </p>
            <ul type="disc">
              <li>
                <strong>Contact Details:&nbsp;</strong>We collect your contact
                information, such as name, postal address, email address,
                telephone or mobile number, fax number, or other similar
                identifiers.
              </li>
              <li>
                <strong>Financial Data:&nbsp;</strong>If you make a purchase
                from us, we collect a credit/debit card number and related
                financial information (such as CVV, expiration date, and billing
                address), depending on the form of payment you choose.
              </li>
              <li>
                <strong>Transaction Details:&nbsp;</strong>We collect details
                about your purchases or other transactions with us, including,
                but not limited to, your transaction or purchase history,
                transaction channel, or the general location of the store you
                visit.
              </li>
              <li>
                <strong>Account Information:&nbsp;</strong>You may choose to
                register for an account to make a purchase or use certain
                services. We collect information from you regarding your account
                registration, such as an email and password.
              </li>
              <li>
                <strong>Marketing and Communications Data:&nbsp;</strong>We
                collect data concerning your preferences in receiving marketing,
                other targeted information from us, and your contact
                preferences.
              </li>
              <li>
                <strong>Demographic Data:&nbsp;</strong>When you enroll in our
                Influencer program or at other times, such as in surveys, we may
                request that you provide birth month and day, gender, and other
                demographic details, and may also collect information about your
                activities and skills, interest, and shopping preferences.
              </li>
              <li>
                <strong>Content and Files:&nbsp;</strong>We may collect other
                information about you based on your interactions with us or that
                you choose to provide to us. For example, if you submit a
                product review you have the option to provide pictures or other
                information about yourself, and if you send us email messages or
                other communications, we will collect and retain those
                communications. If you choose to answer questions about a
                product in a survey or other communication requesting feedback,
                you may provide other information about yourself in your
                response.
              </li>
            </ul>
            <p>
              When you are asked to provide personal information, you may
              decline. And you may use app or device controls to prevent certain
              types of automatic data collection. But if you choose not to
              provide or allow information that is necessary for the Site or
              certain features, those Sites or features may not be available or
              function correctly.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>B. Information We Automatically Collect</strong>
            </p>
            <p>
              When you visit or interact with our Site, we may use a variety of
              technologies such as cookies, web beacons, pixel tags, log files,
              heat mapping, and other technologies to automatically or passively
              collect certain information about your online activity. Please
              note that we automatically collect the following information about
              you:
              <br />
              &nbsp;
            </p>
            <ul type="disc">
              <li>
                <strong>Identifiers and Device Information.</strong> We
                automatically collect your Internet Protocol (IP) address when
                you visit our Site, and other information about your device
                including unique identifiers such as MAC address or information
                from the computer, mobile device, tablet or other device you use
                to access the Site, including but not limited to your device
                type, operating system and version, browser type and language,
                settings and configuration, and information about the location
                of your device.&nbsp;
                <br />
                &nbsp;
              </li>
              <li>
                <strong>Geolocation Data.&nbsp;</strong>We collect certain
                geolocation data when you use our Site.
                <br />
                &nbsp;
              </li>
              <li>
                <strong>Usage Information.&nbsp;</strong>We collect information
                about your usage of and activity on our Site, including the date
                and time you visit the Site, the areas, pages or content of the
                Site that you visit or engage with, the frequency and duration
                of your activities (including but not limited to the amount of
                time you spend viewing or using the Site and the number of times
                you return to the Site), monitoring chat sessions (including
                with the involvement of bots), items that are added to or remain
                in your virtual cart on the Site, other click-stream or site
                usage data, emails that you open, forward or click-through to
                our Site, and other sites that you may visit.
                <br />
                &nbsp;
              </li>
              <li>
                <strong>Video.</strong> When you visit our stores, we
                automatically record video for security, safety and loss
                prevention purposes.
              </li>
            </ul>
            <p>
              <strong>C. Information Collected by Third Parties</strong>
            </p>
            <p>
              Third parties may collect information about your use of the
              Services as described in the{" "}
              <a
                href="#otnotice-section-a305e655-1e6c-4c0f-a501-a6d8e22f4db0"
                rel="noopener noreferrer"
              >
                Third-Party Content, Links, and Plug-Ins
              </a>{" "}
              section and through the use of cookies and other technology as
              described below.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>D. Information Collected from Other Sources</strong>
            </p>
            <p>
              We obtain information from other trusted sources to validate or
              supplement the information that you provide or that we collect
              automatically. These third-party sources and the categories of
              personal information we obtain from these third parties include,
              for example:
              <br />
              &nbsp;
            </p>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Third Party Sources</strong>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Categories of Personal Data&nbsp;
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Data brokers</strong>. Data brokers
                    and aggregators from whom we obtain data to supplement,
                    validate or update the data we collect.&nbsp;
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences&nbsp;
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Third party partners</strong>. Third
                    party applications and services, including social networks
                    you choose to connect with or interact with through our
                    Services, that make users’ information available to
                    others.&nbsp;
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, inferences&nbsp;
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Co-Branding/Joint Partners</strong>.
                    Partners with which we offer co-branded services or engage
                    in joint marketing activities&nbsp;
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, transaction details, account information,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences&nbsp;
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Service providers</strong>. Third
                    parties that collect or provide data in connection with work
                    they do on our behalf, for example companies that determine
                    your device’s location based on its IP address.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Publicly available sources</strong>.
                    Public domain sources of information such as open government
                    databases.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, marketing and communications data,
                    demographic data
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>E. Combination of Information; Inferences</strong>
            </p>
            <p>
              We combine the information we collect from and about you,
              including information you provide to us and information we
              automatically collect through our Site, as well as information
              collected offline, across other computers or devices that you may
              use, and from third party sources. We infer new information from
              other data we collect, including using automated means to generate
              information about your likely preferences or other characteristics
              (“<strong>inferences</strong>”). For example, we infer your city,
              state, and country location based on your IP address, or product
              or shopping preferences based on your transaction history.
            </p>
            <p>&nbsp;</p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-ca2acd7b-b5ae-43f3-aa59-5e374a74d032"
        >
          <h2 className="otnotice-section-header">
            3. Cookies, Mobile IDs and Similar Technologies
          </h2>
          <div className="otnotice-section-content">
            <p>
              We use cookies, web beacons, mobile analytics and advertising IDs,
              and similar technologies to operate the Services and to help
              collect data, including other identifiers and device information
              and usage data. We also use tracking technologies that can create
              heat maps to visualize user behavior (for example, highlighting
              what parts of our Site you viewed and did not view).
              <br id="isPasted" />
              &nbsp;
              <br />
              &nbsp;“Cookies” are text files that are placed on your browser by
              the websites that you visit. Cookies are used for various
              purposes, including to distinguish you from other users, make your
              site navigation more efficient, help remember your preferences,
              enhance your browsing experience, and improve the use and
              functionality of our Site and related content. They can also
              enable the delivery of relevant and personalized advertisements to
              you across the Internet.
              <br />
              &nbsp;
              <br />
              &nbsp;Please note that cookies (and other similar technologies)
              provided by third parties may be placed on our Site and the
              providers of these technologies may combine information collected
              from your interaction(s) with our Services with information they
              collect from other sources and use the combined information for
              analytics and/or advertising purposes.
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-21accac9-85e5-420b-b69b-e1bcadac1058"
        >
          <h2 className="otnotice-section-header">4. Information Use</h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              <strong>A. Use of Information by Parkhaven</strong>
            </p>
            <p>
              We use information we collect for purposes described in this
              Policy or as disclosed to you in other ways including on our Site,
              in our stores, or in connection with other Services. We may use
              this information to help us maintain the accuracy of the
              information we collect, personalize your experience on the Site,
              target our communications so that we can inform you of products,
              Services or other offers that may be of interest to you, to
              measure ad quality and responses, and for internal business
              analysis or other business and commercial purposes. For example,
              we may use your information to:
              <br />
              &nbsp;
            </p>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Purposes of Use</strong>
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Categories of Personal Data&nbsp;
                    </strong>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Product and Service Delivery</strong>.
                    To provide and deliver our products and Services, including
                    securing, troubleshooting, improving, and personalizing
                    those products and the Services.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, video, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Business Operations</strong>. To
                    operate our business, such as billing, accounting, improving
                    our internal operations, securing our systems, and detecting
                    fraudulent or illegal activity.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, video, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">
                      Improvement, Development, and Research
                    </strong>
                    . To test and improve our products and the Services, develop
                    new products or features, and conduct research.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Personalization</strong>. To provide
                    you with customized content, targeted offers, and
                    advertising in the Services, via email, SMS text, direct
                    mail or across other websites, mobile applications, social
                    media or online services you may use.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, transaction details, account information,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Customer Support</strong>. To provide
                    customer support including for product returns, and to
                    respond to your questions.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    <br />
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, video, inferences
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Community</strong>. To manage and
                    administer our community features and member programs and
                    services
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, transaction details, account information,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Communications</strong>. To send you
                    information, including confirmations, invoices, technical
                    notices, updates, security alerts, and support and
                    administrative messages such as Abandoned Cart, to invite
                    you to participate in customer research opportunities, such
                    as surveys and focus groups, and to process and deliver
                    contest entries and awards.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, financial data, transaction details,
                    account information, marketing and communications data,
                    demographic data, content and files, identifiers and device
                    information, geolocation data, usage data, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Marketing</strong>. To send you
                    catalogs and to communicate with you about new products,
                    offers, promotions, contests and sweepstakes, upcoming
                    events, and other news offered by Parkhaven and our selected
                    partners.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, transaction details, account information,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "50.0000%" }}>
                    <strong id="isPasted">Advertising</strong>. To display
                    advertising to you.
                    <br />
                  </td>
                  <td style={{ width: "50.0000%" }}>
                    Contact details, transaction details, account information,
                    marketing and communications data, demographic data, content
                    and files, identifiers and device information, geolocation
                    data, usage data, inferences
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              We also use your information to provide you with other Services or
              for other purposes as disclosed at the time you provide your
              information or otherwise with your consent, e.g., if you are a
              winner of a sweepstakes, we may collect additional personal
              information from you at that time as needed for prize fulfillment.
              <br />
              &nbsp;
            </p>
            <p>
              In carrying out these purposes, we combine data we collect from
              different sources to give you a more seamless, consistent, and
              personalized experience.
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-7a45bedd-a52f-49e3-b563-ee5ac97f8dd5"
        >
          <h2 className="otnotice-section-header">
            5. Sharing Of Personal Information
          </h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              Certain sections of our Site and Services are designed as open and
              public community areas for connecting and sharing with other
              people. When you sign up for or participate in these areas you
              will be asked to provide certain information that may be displayed
              publicly along with photos, stories, posts, product reviews and
              other information you choose to provide. We may also post or
              publish your information when you submit comments, stories,
              photos, and videos in connection with surveys, contests,
              sweepstakes, or promotions offered in the Services.
              <br />
              &nbsp;
            </p>
            <p>
              We share personal information with your consent or as necessary to
              complete your transactions or provide the products you have
              requested or authorized. For example, when you provide payment
              data to make a purchase, we will share that data with banks and
              other entities as necessary for payment processing, fraud
              prevention, credit risk reduction, or other related financial
              services.
              <br />
              &nbsp;
            </p>
            <p>
              In addition, we share all the categories of your personal
              information described above with third parties as follows:
              <br />
              &nbsp;
            </p>
            <ul type="disc">
              <li>
                with your consent, including if we notify you in the Services
                that the information you provide will be shared in a particular
                manner and you provide such information or when you agree to our
                sharing of your information with other third parties for their
                own marketing purposes subject to their separate privacy
                policies;
                <br />
                &nbsp;
              </li>
              <li>
                with our subsidiaries and affiliates including common data
                systems to process personal information as needed to provide our
                products and operate our business;
                <br />
                &nbsp;
              </li>
              <li>
                with vendors, consultants and other service providers who are
                working on our behalf and need access to your information to
                carry out their work for us for the business purposes described
                in this policy, including fulfilling orders or assisting us in
                advertising our products and services on third party websites;
                <br />
                &nbsp;
              </li>
              <li>
                we may share your name, address, email address, telephone
                number, data about your purchases, transaction details, computer
                or device information, usage information, or other similar
                information with our marketing partners or other third parties
                not affiliated with us for commercial purposes. These third
                parties may (i) receive additional information about you from
                service providers and other third parties, and (ii) use the
                information collected from and about you (including the
                information received from us) to contact you via direct mail
                and/or email with selected offers they believe may be of
                interest to you, or to display ads that may be of interest to
                you. If you do not want us to share this information with these
                companies, you may opt out as described in&nbsp;
                <a
                  href="#otnotice-section-fe0ec16e-1bc1-472a-a16c-be4d77b9eec5"
                  rel="noopener noreferrer"
                >
                  "Your Rights, Choices, and Opt-Outs"
                </a>{" "}
                section below.
                <br />
                &nbsp;
              </li>
              <li>
                if you choose to enter into one of our sweepstakes, contests, or
                other promotions (a “Promotion”) we may disclose your
                information to third parties or the public in connection with
                the administration of such Promotion, as required by law, as
                otherwise permitted by the Promotion’s official rules, or
                otherwise in accordance with the terms of this Policy;
                <br />
                &nbsp;
              </li>
              <li>
                to (a) comply with laws or respond to lawful requests and legal
                process, (b) to protect the rights and property of Parkhaven,
                our agents, and others including to enforce our agreements,
                policies and terms of use or (c) in the good faith belief that
                disclosure is needed to respond to an emergency or protect the
                personal safety of any person and to report abusive conduct to
                law enforcement, and/or (d) operate and maintain the security of
                our products, including to prevent or stop spam or attempts to
                commit fraud, or an attack on our computer systems or networks.
                <br />
                &nbsp;
              </li>
              <li>
                in connection with, or during negotiations of corporate
                transactions or proceedings such as a merger, sale of company
                assets, financing, acquisition, bankruptcy, dissolution,
                divestiture, or other transfer of all or a portion of our
                business to another company.
              </li>
            </ul>
            <p>
              Third party analytics and ad tech companies also collect data
              through our website and apps, often through the use of the
              tracking technologies described in{" "}
              <a
                href="#otnotice-section-ca2acd7b-b5ae-43f3-aa59-5e374a74d032"
                rel="noopener noreferrer"
              >
                Section 3
              </a>{" "}
              above, including, transaction details, account information,
              marketing and communications data, demographic data, content and
              files, geolocation data, usage data, and inferences associated
              with identifiers and device information (such as cookie IDs,
              device IDs and IP address).
              <br />
              &nbsp;
            </p>
            <p>
              Finally, we may share other de-identified and/or aggregate
              information in accordance with applicable law.
              <br />
              &nbsp;
            </p>
            <p>
              Please note that some parts of our Site include references or
              links to sites provided by third parties whose privacy practices
              differ from ours. If you provide personal information to any of
              those third parties, or consent to our sharing personal
              information with them, that data is governed by their privacy
              statements.
              <br />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-c74c46e5-067c-44b9-84fe-8d168b9df621"
        >
          <h2 className="otnotice-section-header">
            6. Security of Your Personal Information
          </h2>
          <div className="otnotice-section-content">
            <p>
              Parkhaven takes reasonable and appropriate measures designed to
              protect your personal information in an effort to prevent loss,
              misuse and unauthorized access, disclosure, alteration and
              destruction. Despite our reasonable efforts to help ensure the
              integrity and security of our network and systems, we cannot
              guarantee our security measures. To help protect personal
              information, we request that you use a strong password and never
              share your password with anyone or use the same password with
              other sites or accounts.
              <br id="isPasted" />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-c512e768-5126-4123-86b1-c0dd6fb74641"
        >
          <h2 className="otnotice-section-header">7. Data Storage</h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              This website is operated by Parkhaven Living, LLC, a company that
              is headquartered in the United States of America. To provide you
              with this Website and the goods and Services you order, your data
              may be processed by Parkhaven, its group companies, and its
              service providers, who may be located in countries (including the
              USA) other than your country of residence. These countries may
              have data protection laws that are different than the laws in your
              country of residence, but Parkhaven will protect your personal
              information in accordance with applicable data protection law and
              this Policy at all times.
              <a id="_anchor_2" href="#_msocom_2" />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-fe0ec16e-1bc1-472a-a16c-be4d77b9eec5"
        >
          <h2 className="otnotice-section-header">
            8. Your Rights, Choices, and Opt-Outs
          </h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              <strong>A. Third-Party Opt Outs</strong>
            </p>
            <p>
              You may be able to opt out of receiving certain targeted or
              interest-based advertisements using the browser opt-out tools and
              consumer choice mechanisms provided by an advertising industry
              self-regulatory group by following the link below:
              <br />
              &nbsp;
            </p>

            <ul type="disc">
              <li>
                Your device operating system may provide mechanisms that allow
                you to opt in or opt out of the use of information about your
                use of mobile apps to deliver interest-based advertising to your
                mobile device. For more information, consult your device
                settings.
                <br />
                &nbsp;
              </li>
              <li>
                The DAA offers a tool for opting out of the collection of
                cross-app data on mobile devices for interest-based advertising.
                To exercise your choices with respect to participating
                companies, please download the AppChoices tool at{" "}
                <Link onClick={toTop} to="/">
                  Home
                </Link>
                .
              </li>
            </ul>
            <p>
              You will need to opt out separately on all of your browsers and
              devices, as each opt out will apply only to the specific browser
              or device from which you opt out. If you delete or reset your
              cookies or mobile identifiers, change browsers, or use a different
              device, any opt-out cookie or tool may no longer work and you will
              have to opt out again.
              <br />
              &nbsp;
            </p>
            <p>
              Even if you choose to opt out of receiving interest-based
              advertising, you may still receive advertising, but the
              advertisements may be less relevant.
              <br />
              &nbsp;
            </p>
            <p>
              Some of our partners may provide you with additional choices with
              respect to interest-based advertising. For example, certain social
              media platforms allow you to control your advertising preferences
              directly through their services. Please review the privacy
              policies of the third-party services you use for more information.
              <br />
              &nbsp;
            </p>
            <p>
              If you reside in the United States, depending on your state of
              residency, you may have additional choices with respect to our use
              and disclosure of information for sale and interest-based
              advertising purposes. Details on how to exercise your legal rights
              can be found below in Section 8.F, “Opt-Out Requests.”
              <br />
              &nbsp;
            </p>
            <p>
              <strong>
                B. Unsubscribing from our Marketing and Promotional
                Communications, Including Catalog Mailings
              </strong>
            </p>
            <p>
              You may opt out of receiving promotional emails from Parkhaven by
              following the instructions in those emails or using this&nbsp;
              <Link onClick={toTop} to="/">
                Unsubscribe Link
              </Link>{" "}
              and entering the email address you wish to unsubscribe. If you
              choose to opt out of promotional emails, we may still send you
              non-promotional emails, such as emails about your accounts or our
              ongoing business relations.
              <br />
              &nbsp;
            </p>
            <p>
              You can opt out of receiving our catalogs by going to this&nbsp;
              <Link onClick={toTop} to="/">
                page
              </Link>{" "}
              and doing the following: (i) check the box “Catalog – Remove me
              from you catalog list” (at bottom of form under the “Submit
              Request” button); (ii) and provide your name and address in the
              form that pops up and click the Submit Request button at bottom of
              form.
              <br />
              &nbsp;
            </p>
            <p>
              You can opt out of receiving promotional text messages or calls to
              your phone number at any time by (i) for text messages, texting
              “STOP” in response to any text message you receive from us or
              contacting us at 1-866-915-6457 during normal business hours and
              specifying you want to opt out of text messages; and (ii) for
              calls, requesting opt-out during any call you receive from us or
              contacting us at 1-866-915-6457 during normal business hours and
              specifying you want to opt out of calls.
              <br />
              &nbsp;
            </p>
            <p>
              You may also send requests about your contact preferences or
              changes to your information by contacting us through the channels
              listed or by writing us at:
              <br />
              &nbsp;
            </p>
            <p>
              Parkhaven Customer Service
              <br />
              <span
                style={{
                  color: "rgb(0, 0, 0)",
                  fontFamily:
                    '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "Lucinda Grande", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                  fontSize: 14,
                  fontStyle: "normal",
                  fontVariantLigatures: "normal",
                  fontVariantCaps: "normal",
                  fontWeight: 400,
                  letterSpacing: "normal",
                  orphans: 2,
                  textAlign: "left",
                  textIndent: 0,
                  textTransform: "none",
                  widows: 2,
                  wordSpacing: 0,
                  WebkitTextStrokeWidth: 0,
                  whiteSpace: "normal",
                  backgroundColor: "rgb(255, 255, 255)",
                  textDecorationThickness: "initial",
                  textDecorationStyle: "initial",
                  textDecorationColor: "initial",
                  display: "inline !important",
                  float: "none",
                }}
                id="isPasted"
              >
                14375 N.W. Science Park Dr.
              </span>
              <br
                style={{
                  boxSizing: "inherit",
                  color: "rgb(0, 0, 0)",
                  fontFamily:
                    '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "Lucinda Grande", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                  fontSize: 14,
                  fontStyle: "normal",
                  fontVariantLigatures: "normal",
                  fontVariantCaps: "normal",
                  fontWeight: 400,
                  letterSpacing: "normal",
                  orphans: 2,
                  textAlign: "left",
                  textIndent: 0,
                  textTransform: "none",
                  widows: 2,
                  wordSpacing: 0,
                  WebkitTextStrokeWidth: 0,
                  whiteSpace: "normal",
                  backgroundColor: "rgb(255, 255, 255)",
                  textDecorationThickness: "initial",
                  textDecorationStyle: "initial",
                  textDecorationColor: "initial",
                }}
              />
              <span
                style={{
                  color: "rgb(0, 0, 0)",
                  fontFamily:
                    '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, "Lucinda Grande", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                  fontSize: 14,
                  fontStyle: "normal",
                  fontVariantLigatures: "normal",
                  fontVariantCaps: "normal",
                  fontWeight: 400,
                  letterSpacing: "normal",
                  orphans: 2,
                  textAlign: "left",
                  textIndent: 0,
                  textTransform: "none",
                  widows: 2,
                  wordSpacing: 0,
                  WebkitTextStrokeWidth: 0,
                  whiteSpace: "normal",
                  backgroundColor: "rgb(255, 255, 255)",
                  textDecorationThickness: "initial",
                  textDecorationStyle: "initial",
                  textDecorationColor: "initial",
                  display: "inline !important",
                  float: "none",
                }}
              >
                Portland, OR 97229
              </span>
              <br />
              &nbsp;
            </p>
            <p>
              <strong>C. Opting Out of Location Collection</strong>
            </p>
            <p>
              You may opt out from allowing Parkhaven to collect certain
              geographic location by changing your location preferences in your
              web browser or on your mobile device. We and others may still
              collect other geographic location information such as address,
              city and state that you directly provide or zip code, city and
              state inferred from your IP address.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>
                D. Privacy Rights and Requests
                <br />
                &nbsp;
              </strong>
            </p>
            <p>
              Depending on your U.S. state of residence, you may have certain
              rights in relation to your personal information, including:
              <br />
              &nbsp;
            </p>
            <ul type="disc">
              <li>
                <strong>Right to Know</strong>: You may have the right to know
                what personal information we have collected about you, including
                the categories of sources from which the personal information is
                collected, the business or commercial purpose for collecting,
                selling, or sharing personal information, the categories of
                third parties to whom we disclose personal information, and the
                specific pieces of personal information we have collected about
                you. Please note that we may not be required to respond to your
                requests “to know” or access specific pieces of personal
                information more than twice in any 12-month period.
              </li>
            </ul>
            <ul>
              <li id="isPasted">
                <strong>Right to Request Specific List of Third Parties</strong>
                : You may have the right to request a list of the specific third
                parties to which we disclose personal information. &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
              </li>
              <li>
                <strong>Right to Data Portability</strong>: You may have the
                right to access your information in a portable format.
                <br />
                &nbsp;
              </li>
              <li>
                <strong>Right to Delete</strong>: You may have the right to
                request that we delete personal information that we have
                collected from you, subject to certain exceptions.
                <br />
                &nbsp;
              </li>
              <li>
                <strong>Right to Correct</strong>: You may have the right to
                correct inaccurate personal information that we may maintain
                about you, subject to appropriate verification.
                <br />
                &nbsp;
              </li>
              <li>
                <strong>
                  Right to Opt Out of Certain Types of Personal Information Uses
                  and Disclosures
                </strong>
                : We use and disclose to third parties’ personal information for
                analytics and advertising purposes. Accordingly, you may have
                the right to opt out of the “sale” or "sharing” of your personal
                information, or the use and disclosure of your personal
                information for “targeted advertising” (as these terms are
                defined in applicable law).
              </li>
            </ul>
            <p>You may exercise these rights as follows:</p>
            <ul>
              <li>
                <strong>
                  To exercise the right to opt out of the “sale” or “sharing” of
                  your personal information, including targeted advertising,
                </strong>{" "}
                click{" "}
                <Link onClick={toTop} to="/">
                  here
                </Link>{" "}
                and follow the instructions on that page.&nbsp;
              </li>
              <li>
                <strong id="isPasted">
                  To exercise the right to know and the right to delete
                </strong>
                , please click{" "}
                <Link onClick={toTop} to="/">
                  here
                </Link>{" "}
                or you can contact us at 1-866-915-6457 during normal business
                hours.&nbsp;
              </li>
              <li id="isPasted">
                <strong>
                  To exercise the right to data portability and the right to
                  correct
                </strong>
                , please contact us a{" "}
                <Link onClick={toTop} to="/">
                  enter@parkhaven.cloud
                </Link>{" "}
                or at1-866-915-6457 during normal business hours. When
                submitting a written request to correct your data or access your
                information in a portable format, please include “Request to
                Correct” or “Data Portability Request,” as applicable in the
                subject line.
              </li>
            </ul>
            <p>
              We may take steps to verify your identity before responding to
              your request by asking you a series of questions about your
              previous interactions with us. Submitting a privacy rights request
              does not require you to create an account with us.
              <br />
              &nbsp;
            </p>
            <p>
              We will not discriminate against you if you decide to exercise
              your privacy rights.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>E. Agent Requests</strong>
            </p>
            <p>
              Only you, or someone legally authorized to act on your behalf, may
              submit a request related to your personal information. You may
              also submit a request on behalf of your minor child.
              <br />
              &nbsp;
            </p>
            <p>
              Depending on your U.S. state of residence, you may authorize
              someone to make a privacy rights request on your behalf (an
              authorized agent). Authorized agents will need to demonstrate that
              you’ve authorized them to act on your behalf. Parkhaven retains
              the right to request confirmation directly from you confirming
              that the agent is authorized to make such a request, or to request
              additional information to confirm the agent’s identity.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>F. Opt-Out Requests</strong>
            </p>
            <p>
              You may request to opt out of the sale or sharing of your personal
              information, or of targeted advertising, at any time by clicking
              the “Do Not Sell or Share My Personal Information” link&nbsp;
              <Link onClick={toTop} to="/">
                here
              </Link>{" "}
              or at the bottom of the Site’s homepage, or contact us at
              1-866-915-6457 during normal business hours.
              <br />
              &nbsp;
            </p>
            <p>
              Submitting an opt-out request does not require you to create an
              account with us.
              <br />
              &nbsp;
            </p>
            <p>
              Alternatively, you can use certain preference signals to exercise
              your sale and sharing opt-out right automatically with all
              businesses that you interact with online, including Parkhaven. If
              you enable a browser-based opt-out preference signal, such as
              Global Privacy Control (GPC), upon receipt or detection, we will
              treat the signal as a valid request to opt out of the sale or
              sharing of personal information linked to that browser and any
              consumer profile we have associated with that browser, however,
              you will still need to follow instructions on the&nbsp;
              <Link onClick={toTop} to="/">
                “Do Not Sell or Share My Personal Information”
              </Link>{" "}
              page to opt out of certain offline sales or sharing of personal
              information. Please note that if you use different browsers or
              browser profiles, you will have to enable the signal on each
              browser or profile.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>G. Right to Appeal</strong>
            </p>
            <p>
              Depending on your U.S. state of residence, you may have the right
              to appeal a decision we have made in connection with your privacy
              rights request. To appeal a decision, please contact us at&nbsp;
              <Link onClick={toTop} to="/">
                enter@parkhaven.cloud
              </Link>{" "}
              with “Appeal of Privacy Rights Request” in the subject line.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>H. Notice of Financial Incentive.</strong>
            </p>
            <p>
              We offer discounted prices to consumers who apply to enroll in our
              Parkhaven Pro Program (“Pro Program”) and meet certain eligibility
              criteria and voluntarily provide certain requested personal
              information to us in an application to enroll. You can find a full
              description of the Pro Program, including the benefits offered,{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>{" "}
              and related legal terms,{" "}
              <Link onClick={toTop} to="/">
                here
              </Link>
              . To enroll in our Pro Program you must complete an application
              and submit your name, Pro classification (e.g. Fitness Based
              Instructor, Non Profit Employee, etc.), email address, mailing
              address, phone number, and the name of your business/organization
              and business phone, along with verification documentation to
              confirm eligibility for the Pro Program. You must also create a
              password for your Pro Program account. Access to the Pro Program
              expires annually, and to continue to participate you must reapply
              online and provide eligibility verification. You may disenroll
              from the Pro Program at any time by reaching out to Customer
              Service&nbsp;
              <Link onClick={toTop} to="/">
                here
              </Link>
              .<br />
              &nbsp;
            </p>
            <p>
              We may also offer an initial one-time discount and other
              promotional offerings to consumers who subscribe to our marketing
              emails and SMS messages, and we may provide other programs, such
              as sweepstakes, contests, or other similar promotional campaigns
              (“Programs”). When you sign up for one of these Programs, we
              typically ask you to provide your name and email address or other
              contact information.
              <br />
              &nbsp;
            </p>
            <p>
              Because the Parkhaven Pro Program and these other Programs involve
              the collection of personal information, they might be interpreted
              as “financial incentive” programs under California law or “bona
              fide loyalty” programs under Colorado law. Parkhaven uses this
              information for the purposes described above in our notice under
              the section titled{" "}
              <a
                href="#otnotice-section-abc60a93-93bb-41f2-883f-44fecd30237f"
                rel="noopener noreferrer"
              >
                "Notice at Collection of Personal Information"
              </a>{" "}
              including for targeted advertising. Parkhaven may share your
              personal information with third parties as described in our&nbsp;
              <a
                href="#otnotice-section-abc60a93-93bb-41f2-883f-44fecd30237f"
                rel="noopener noreferrer"
              >
                "Notice at Collection of Personal Information,"
              </a>{" "}
              including data analytics providers, advertising technology
              vendors, and social media platforms. The value of any financial
              incentive we offer is reasonably related to the value of any
              personal information you provide to us. We estimate the value of
              your personal information by considering, without limitation, the
              expenses we incur from collecting your personal information and/or
              providing the financial incentive to you, the revenue generated by
              your use of the financial incentive, and any improvements we can
              make to our products and Services based on aggregating information
              obtained through the financial incentive program.
              <br />
              &nbsp;
            </p>
            <p>
              You can unsubscribe from our marketing emails at any time by
              following the instructions in those emails or using this&nbsp;
              <Link onClick={toTop} to="/">
                Unsubscribe Link
              </Link>
              . If you are enrolled in the Pro Program and you choose to opt out
              of marketing emails, you will continue to receive communications
              regarding your participation in the Pro Program and any changes to
              the Pro Program via email.
              <br />
              &nbsp;
            </p>
            <p>
              <strong>I. Shine The Light</strong>
            </p>
            <p>
              Under California Civil Code section 1798.83, also known as the
              “Shine the Light” law, if you are a California customer you may
              opt out of our disclosure of personal information to third parties
              for their direct marketing purposes. To opt out, please contact us
              at&nbsp;
              <Link onClick={toTop} to="/">
                enter@parkhaven.cloud
              </Link>
              . You must put the statement “Your California Privacy Rights” in
              the subject field. We are not responsible for notices that are not
              labeled or sent properly, or do not have complete information.
              <br />
              &nbsp;
            </p>
            <p>
              Non-affiliated third parties are independent from Parkhaven and if
              you wish to receive information about your disclosure choices or
              stop communications from such third parties, you will need to
              contact those non-affiliated third parties directly.
            </p>
            <p>
              <br />
            </p>
            <p>
              <strong>J.</strong>{" "}
              <strong id="isPasted">
                Additional Disclosures for Nevada Residents
              </strong>
            </p>
            <p>
              Nevada law (NRS 603A.340) requires each business to establish a
              designated request address where Nevada consumers may submit
              requests directing the business not to sell certain kinds of
              personal information that the business has collected or will
              collect about the consumer. A sale under Nevada law is the
              exchange of personal information for monetary consideration by the
              business to a third party for the third party to license or sell
              the personal information to other third parties. Parkhaven does
              not sell consumers’ personal information for monetary
              consideration to third parties for licensing or sale to other
              third parties. If you are a Nevada consumer and wish to submit an
              inquiry relating to our compliance with Nevada law, please contact
              us as at{" "}
              <Link onClick={toTop} to="/">
                enter@parkhaven.cloud
              </Link>
              .
              <strong id="isPasted">
                <br />
                &nbsp;
              </strong>
            </p>
            <div id="_com_1" language="JavaScript">
              <br />
            </div>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-4a3e7d74-1aba-4c83-8203-8e5dc151444d"
        >
          <h2 className="otnotice-section-header">9. Children's Privacy</h2>
          <div className="otnotice-section-content">
            <p>
              Our Services are intended for a general audience. We do not direct
              our Services to children under eighteen (18), nor do we knowingly
              solicit or collect any personal information from children under
              the age of eighteen (18). If you are under the age of 18 you
              should not provide any personal information to us. If you are a
              parent or legal guardian and think that your child has given us
              data, you can contact us in writing or by email as provided below
              under the section titled
              <a
                href="#otnotice-section-4b82fa80-39fd-4fa0-8ddb-8e53d628cc16"
                rel="noopener noreferrer"
              >
                "Questions/Contact us"
              </a>{" "}
              “Questions/Contact us.” Please mark your inquiries “Children’s
              Privacy Information Request.” If we learn that a minor has
              provided personal information through our Services, we will use
              reasonable efforts to remove such information from our files.
              <br id="isPasted" />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-a305e655-1e6c-4c0f-a501-a6d8e22f4db0"
        >
          <h2 className="otnotice-section-header">
            10. Third-Party Content, Links, and Plug-Ins
          </h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              The Site may have links to third-party websites, which may have
              privacy policies that differ from our own. We are not responsible
              for the practices of such sites.
              <br />
              &nbsp;
            </p>
            <p>
              The Services may also offer you the ability to interact with
              social plugins from social media sites, which may allow us and/or
              the social media site to receive data from or about you. In some
              cases, we may know that you clicked on a social plugin, such as a
              Twitter Follow button, or receive other information from the
              social media sites. Similarly, if you have previously provided
              personal information to a third-party operating a plug-in on this
              Site, then such third-party may recognize you on this Site. Your
              use of social network plugins is subject to each social media
              site’s privacy policy, which may be different from ours, so please
              read these policies carefully to understand their policies and
              your options. As with linked sites, we have no control over the
              information that is collected, stored, or used by social network
              plugins, and are not responsible for the practices of such sites.
            </p>
            <p>&nbsp;</p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-638a372f-94be-4571-804a-b4b5b08a8fcb"
        >
          <h2 className="otnotice-section-header">
            11. Changes To This Policy
          </h2>
          <div className="otnotice-section-content">
            <p>
              Parkhaven will change this Policy from time to time to reflect
              changes in our products, how we use personal information, or the
              applicable law. When we make any changes to this Policy, we will
              change the "Last Updated" date above. If we make material changes
              to this Policy, we will provide notice or obtain consent regarding
              such changes as may be required by law. Such notice may be
              provided via a temporary banner on our Site, an email sent to
              users for whom we have an email address, or by temporarily noting
              “UPDATED” next to the Privacy Policy link on the footer of our
              Site. &nbsp;&nbsp;
              <br id="isPasted" />
              &nbsp;
            </p>
          </div>
        </section>
        <section
          className="otnotice-section"
          id="otnotice-section-4b82fa80-39fd-4fa0-8ddb-8e53d628cc16"
        >
          <h2 className="otnotice-section-header">12. Questions/Contact Us</h2>
          <div className="otnotice-section-content">
            <p id="isPasted">
              If you have any questions or concerns about this Policy or our
              privacy practices, you may email us at{" "}
              <Link onClick={toTop} to="/">
                enter@parkhaven.cloud
              </Link>{" "}
              or write us at:address:
            </p>
            <p>413 Carrington Ln, Douglasville, GA 30135US</p>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Privacy;
